import React from "react";
import { makeStyles, Paper, Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { BackIcon } from "../../../shared-resources/SVGIcons";
import Delegations from "./Delegations";

const ResourceDelegations = () => {
  const history = useHistory();
  const useStyles = makeStyles({
    paperTitle: {
      color: "#0070D2",
      fontSize: "16px",
      fontWeight: 600,
      padding: "4px 16px",
      boxShadow: "0px 3px 6px #00000029",
      borderRadius: "8px",
    },
  });
  const classes = useStyles();

  const onBackClick = () => {
    history.push("/projects/resource-management");
  };

  return (
    <div style={{ padding: "12px" }}>
      <Paper elevation={0} className={classes.paperTitle}>
        <Grid container spacing={0}>
          <Grid item lg={10} style={{ margin: "12px 0" }}>
            <span
              onClick={onBackClick}
              style={{
                float: "left",
                marginRight: "16px",
                cursor: "pointer",
              }}
            >
              {BackIcon()}
            </span>
            Resource Delegations
          </Grid>
        </Grid>
      </Paper>
      <div style={{ margin: "12px 0 0 0" }}>
        <Delegations />
      </div>
    </div>
  );
};

export default ResourceDelegations;
